import React from "react";
import Banner from "./Banner";
import Footer from "./Footer";
import { FaRegBuilding } from "react-icons/fa";
import {BiSolidPhoneCall} from "react-icons/bi";
import {AiOutlineMail} from "react-icons/ai";

const Contact_us = () => {
  return (
    <>
      <Banner />

      <div className="home_header">
        <h1 className="home_header">Contact Us</h1>
      </div>

      <div className="location_container">
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d28018.779032127884!2d76.99948401082996!3d28.619349099999994!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390ce3de9c8c4cb1%3A0x3e1d9a9d183cf7a4!2sTIME%20Cyber%20Media%20Pvt%20Ltd!5e0!3m2!1sen!2sus!4v1690453430614!5m2!1sen!2sus"
          width="100%"
          height="450"
          allowFullscreen=""
          loading="lazy"
          referrerpolicy="no-referrer-when-downgrade"
        ></iframe>
      </div>

      <div className="contact_form_container">
        <div className="contact_form_row">
          <div className="form_container">
            <form>
              <div className="firstname_input input">
              <label>Firsr Name</label>
                <input type="text" name="" required="" placeholder=""/>  
              </div>
              <div className="email_input input">
              <label>Email Address</label>
                <input type="text" name="" required="" placeholder=""/>  
              </div>
              <div className="phone_input input">
              <label>Phone</label>
                <input type="text" name="" required="" placeholder=""/> 
              </div>
              <div className="msg_input">
                <textarea cols={40} rows={5}  placeholder="" type="text">
                  Message
                </textarea>
              </div>
              <div className="submit_container">
                
                  <input type="Submit" placeholder="SEND MESSAGE" value="submit"/>
              
              </div>
            </form>
          </div>

          <div className="Get_In_Touch">
            <h1>Get In Touch</h1>
            <div className="register_office_container">
              <div className="register_row">
                <span className="register_icon">
                  <FaRegBuilding size={50}/>
                </span>
                <span className="register_info">
                  <h2>Register Office</h2>
                  <p>
                    C-31, 3rd Floor, Nawada Housing Complex, Opp. Metro Piller<br/>
                    No 792, Shivaji Marg, New Delhi 110059
                  </p>
                </span>
              </div>
            </div>
            <div className="second_row">
              <span className="call_us_container">
                <span className="call_row">
                  <span className="call_us_icon">
                  <BiSolidPhoneCall size={50}/>
                  </span>

                  <div className="call_info">
                    <h2>Call Us</h2>
                    <p>+91-9821020995</p>
                    <p>+91-9873004416</p>
                  </div>
                </span>
              </span>
              <span className="email_container">
                <div className="email_row">
                  <span className="email_icon">
                  <AiOutlineMail size={50} color="yellow"/>
                  </span>
                  <div className="email_info">
                    <h2>Email Information</h2>
                    <a>info@timescyber</a>
                  </div>
                </div>
              </span>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default Contact_us;
